require('babel-polyfill')

import Vue from 'vue'

import CoreuiVue from '@coreui/vue';
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import ToastService from 'primevue/toastservice';
Vue.use(ToastService);
Vue.use(CoreuiVue)

import _http from './plugins/http'
import version from '../config'

export const bus = new Vue();

const dotenv = require('dotenv');
dotenv.config();

import VuejsDialog from 'vuejs-dialog';
import './assets/css/vuejs-dialog.min.css';
let params = new URLSearchParams(location.search);
var themeUrl = params.get('theme');

import types from "./ThemeJs/theme";
var themeUrlName;
switch (themeUrl) {
  case '1':
    themeUrlName = 'holcimRedAlternative';
    break;
  case '2':
    themeUrlName = 'laFargeGreenAlternative';
    break;
  case '3':
    themeUrlName = 'laFargeHolcimblueAlternative';
    break;

  default:
    themeUrlName = 'laFargeGreenAlternative';
    break;
}

// dummy commit

if (localStorage.theme === undefined || localStorage.theme === null) {
  // console.log("local dentro del if")
  localStorage.theme = themeUrlName;
  types['types'].theme.map((theme) => {
    if (theme.name == themeUrl) {
      theme.state = true;

    } else {
      theme.state = false;

    }
  })
  let tema = types.types.theme.filter(themeElement => themeElement.name == themeUrl);
  // console.log(tema, "tema");
  types.selectTheme(tema);
} else {
  types['types'].theme.map((theme) => {
    if (theme.name == localStorage.theme) {
      theme.state = true;

    } else {
      theme.state = false;

    }
  })
  let tema = types.types.theme.filter(themeElement => themeElement.name == localStorage.theme);
  // console.log(tema, "tema");
  types.selectTheme(tema);
}


Vue.use(VuejsDialog);
Vue.prototype.$version = version.general.version;


import i18n from './i18n.js';

/**
 * $tf(key, fallback) — translate with guaranteed fallback.
 *
 * $t(key) returns '[_key_]' or '[__key__]' (truthy) for missing translations,
 * so "$t('key') || 'fallback'" never fires. Use $tf instead:
 *   {{ $tf('some_key', 'My Label') }}
 */
Vue.prototype.$tf = function(key, fallback) {
  const t = this.$t(key);
  if (!t || /^\[_+.+_+\]$/.test(t)) return fallback !== undefined ? fallback : key;
  return t;
};



// TODO: configuracion common functions
import './plugins/commons'

// console.log("despues exportssssssssssssssssss")


// TODO: configuracion de axios
Vue.use(_http)


Vue.prototype.$error = function (data) {


  if ((data.ret == '403') || (data.ret == '401')) {


    let msg = '';
    if (data.ret == '403') msg = i18n.i18next.t('expired_sesion_message');
    if (data.ret == '401') msg = i18n.i18next.t('access_denied_message') + '(' + data.msg + ') ';

    this.$dialog
      .alert(msg)
      .then(function (dialog) {
        localStorage.removeItem("user");
        localStorage.removeItem("userRol");
        location.href = '/#/login';
      })
      .catch(function () { });
      localStorage.removeItem("user");
      localStorage.removeItem("userRol");


  } else {

    let msg = '';
    try { msg = data.msg.msg; } catch (e) { msg = data.toString(); }
    if (msg === undefined) msg = data.msg;


    let error = msg;

    msg = i18n.i18next.t('unavailable_service_message') + ` <br/> <a href="#" data-msg="${escape(error)}" onclick="showError(this);">${i18n.i18next.t('close')}</a>`;



    Vue.notify({
      group: 'app',
      title: i18n.i18next.t('error'),
      type: 'error',
      text: msg,
      duration: -1
    });


  }

}

export function getEnvironment() {
  return new Promise(resolve => {
    Vue.prototype.$http.get(`/getEnv`)
      .then((res) => {
        let url_res=res.data;
        console.log(url_res)
        resolve(url_res);
      })
      .catch(error => {
        resolve({ ret: error.response.status, msg: error.response.data })
      })
  })
}

import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

import BlockUI from 'vue-blockui'

Vue.use(BlockUI)
Vue.use(VueLogger, options);

Vue.config.productionTip = false;


import Notifications from 'vue-notification'
Vue.use(Notifications)

let SesionIddle = 1000 * 60 * 30;
const eventsHub = new Vue()

import IdleVue from 'idle-vue'
Vue.use(IdleVue, {
  idleTime: SesionIddle,
  eventEmitter: eventsHub
})

Vue.config.errorHandler = function (err, vm, info) {
  console.error(`Error: ${err.toString()}\nInfo: ${info}`);
}



new Vue({
  el: '#app',
  router,
  i18n,
  icons,
  template: '<App/>',
  components: {
    App
  },

  created: function () {
    this.loadGigyaApiScript();
  },

  methods: {
    loadGigyaApiScript() {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", "/CIAM/apikey", true);
      xhr.onload = (e) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            
            const script = document.createElement('script');
            script.src = `https://cdns.gigya.com/js/gigya.js?apikey=${xhr.responseText}`;
            script.onload = () => console.log('CIAM API script loaded successfully');
            document.head.appendChild(script);
          }
        }
      };
      xhr.send(null);

     
    }
  },

  // onIdle() {
  //   var user = localStorage.getItem("user");

  //   if (user != null) {
  //     localStorage.removeItem("user");
  //     //this.$router.push('login');
  //     location.href = '#/login?t' + (new Date()).getMilliseconds();
  //   }


  // },

  onActive() { }
})

